import { Fragment, useContext, useRef, useState } from 'react';

import { PlusCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Image, Popover, message } from 'antd';
import { chunk } from 'lodash-es';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import { addCartBall } from './purchaseButton';

import { cartAddNormal } from '@lcsc-ui/apis/cart';
import Colon from '@lcsc-ui/components/Colon';
import InputSelect from '@lcsc-ui/components/InputSelect';
import LabelText from '@lcsc-ui/components/LabelText';
import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';
import { ProductItemContext } from '@lcsc-ui/providers/productItem';
import { ProductListContext } from '@lcsc-ui/providers/productList';
import useUserStore from '@lcsc-ui/store/user';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Utils from '@lcsc-ui/utils/Utils';
// 优惠套装
export default function DiscountSuite({ promotionList }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const { userInfo, updateUserInfo } = useUserStore();
  const { searchResult, track_zone } = useContext(ProductListContext);
  const { productVO: mainProductVO, index: mainProductIndex, rs_log } = useContext(ProductItemContext);
  const swiperRef = useRef(null);
  const addBtnRefs = useRef([]);
  const purchaseCount = useRef([]);

  function clickPagation(index) {
    swiperRef.current.slideTo(index);
    setActiveIndex(index);
  }

  function handleInputChange(index, value) {
    purchaseCount.current[index] = value;
  }

  function addCart(index) {
    if (loading) {
      return;
    }
    const cartKeyStrList = promotionList[index]?.packagePromotionProductList.map((item) => {
      return `0~${item?.productId}~RMB~CN~${(purchaseCount.current[index] * item?.productNumber) / item?.convesionRatio || 1}`;
    });
    setLoading(true);
    const { spm, lcsc_vid } = Utils.getButtonParams(addBtnRefs.current[index]);
    cartAddNormal({
      cartKeyStr: cartKeyStrList.join(),
      entryType: 'product_choose_buy',
      lcscVid: lcsc_vid,
      spm,
    })
      .then((res) => {
        message.success('加入购物车成功！');
        addCartBall(addBtnRefs.current[index], () => {
          updateUserInfo({
            ...userInfo,
            cartNum: res?.result?.cart_contains_count,
          });
        });
      })
      .catch((error) => {
        if (error?.shifting) {
          message.error(error?.shifting);
        } else if (error.needLogin) {
          Utils.showWindowLogin();
        } else {
          message.error(error?.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        buriedPoint({
          op: 'ADD_CART',
          data: {
            pc: mainProductVO?.productId,
            brand: mainProductVO?.productGradePlateName,
            model: mainProductVO?.productModel,
            code: mainProductVO?.productCode,
            kw: searchResult?.globalSearchKeyword,
            cp: searchResult?.currePage,
            ix: mainProductIndex,
            no: purchaseCount.current[index],
            type: 'main_products',
            price: purchaseCount.current[index] * promotionList[index]?.packageMoney,
            track_zone: track_zone,
            rs_log,
          },
        });
      });
  }

  function groupFormat(list) {
    if (Array.isArray(list) && list.length) {
      return chunk(list, 3);
    }
    return [];
  }

  return (
    <>
      {promotionList?.map((promotion, index) => {
        return (
          <div className="relative bg-[#fff] px-[20px] pt-[14px]" key={index}>
            <div>
              <p className="mb-[11px] flex items-center">
                <b className="mr-[5px] text-[14px] text-[#444]">{promotion?.packagePromotionName}</b>
                <Popover
                  content={
                    <div className="p-[10px_10px_15px_10px] leading-[18px]">
                      <p>套装商品需要把一整套商品以其对应的数量购买才能享受套装优惠</p>
                      {promotion.purchaseLimit && (
                        <p>
                          单客户{promotion.isDaily && '每日'}限购优惠套数：
                          {promotion.purchaseLimit}
                        </p>
                      )}
                      <p>
                        {promotion.packagePromotionName}套装：-￥
                        {promotion.dicountMoney}
                      </p>
                    </div>
                  }
                  overlayClassName="lcsc-popover-wrapper"
                >
                  <QuestionCircleOutlined className="text-[16px] text-[#d5d5d5]" />
                </Popover>
              </p>
              <div className="flex">
                <Swiper
                  navigation={true}
                  modules={[Pagination]}
                  pagination={{ clickable: true }}
                  onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                  }}
                  onSlideChange={(swiper) => {
                    setActiveIndex(swiper.realIndex);
                  }}
                  className="flex flex-1 items-start"
                >
                  {groupFormat(promotion?.packagePromotionProductList).map((list, k) => (
                    <SwiperSlide key={k} className="mb-[20px]">
                      <div className="flex items-center justify-between">
                        {list?.map((product, i) => (
                          <Fragment key={i}>
                            {i > 0 && <PlusCircleOutlined className="mr-[80px] text-[30px] text-[#e4e4e4]" />}
                            <SuiteItem spm={`tz${index + 1}-${k * 3 + i + 1}`} productVO={product} />
                          </Fragment>
                        ))}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <div className="_lg:w-[140px] w-[120px]">
                  <InputSelect
                    className="w-full"
                    defaultCount={1}
                    defaultUnit="套"
                    productUnit="套"
                    theRatio={1}
                    minBuyNumber={1}
                    stockNumber={promotion.purchaseLimit || promotion.packagePromotionNumber}
                    onChange={(val) => handleInputChange(index, val)}
                  />
                  <p className="mb-[4px] mt-[8px] text-right">
                    <span className="text-[#69788a]">
                      套装价
                      <Colon />
                    </span>
                    <span className="text-[#444]">￥{promotion?.packageMoney}</span>
                  </p>
                  <p className="mb-[10px] text-right text-[#BFBFBF]">
                    原价
                    <Colon />￥{promotion?.totalMoney}
                  </p>
                  <Button
                    ref={(el) => (addBtnRefs.current[index] = el)}
                    className="mb-[22px] block w-full"
                    type="primary"
                    onClick={() => addCart(index)}
                    data-spm="iad"
                  >
                    加购套装
                  </Button>
                </div>
              </div>
            </div>
            <ul className="absolute bottom-[20px] left-[50%] z-[3] translate-x-[-50%]">
              {groupFormat(promotion?.packagePromotionProductList)?.length > 1 &&
                groupFormat(promotion?.packagePromotionProductList)?.map((_, index) => {
                  const active = index === activeIndex ? 'bg-[#1FA0E8]' : 'bg-[#000]';
                  return (
                    <li
                      key={index}
                      className={`index-banner-pagination ${active} mx-[6px] inline-block size-[10px] cursor-pointer rounded-[50%] bg-[#000] opacity-[0.2]`}
                      onClick={() => clickPagation(index)}
                    ></li>
                  );
                })}
            </ul>
          </div>
        );
      })}
    </>
  );
}

function SuiteItem({ productVO, spm }) {
  const { resourceData } = useContext(LayoutContext);

  return (
    <div data-spm={spm} className="flex flex-1">
      <a
        data-spm="t"
        href={`${resourceData?.projectConfigVO?.lcscItemUrl}/${productVO?.productId}.html`}
        target="_blank"
      >
        <Image
          width={85}
          height={85}
          className="rounded-[4px]"
          src={productVO?.productImgUrl}
          preview={false}
          fallback="https://static.szlcsc.com/ecp/assets/web/static/images/default_pic.gif"
          alt={'产品详情'}
        ></Image>
      </a>
      <div className="ml-[10px]">
        <LabelText
          spm="n"
          text={productVO?.productModel}
          isTitle
          link={`${resourceData?.projectConfigVO?.lcscItemUrl}/${productVO?.productId}.html`}
        ></LabelText>
        <LabelText label="品牌" text={productVO?.brandName}></LabelText>
        <LabelText label="封装" text={productVO?.encapStandard}></LabelText>
        <LabelText label="数量" text={productVO?.productNumber}></LabelText>
      </div>
    </div>
  );
}
